export default __webpack_public_path__ + "static/media/Premiumplus.d9774a64.webp";